// extracted by mini-css-extract-plugin
export default {"DeregistrationDialog":"XxOnS","download":"w1xl8","submissionMessage":"IpeFV","imageDiv":"PllY8","imgDivBg":"x7iZw"};